import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToWords } from 'to-words';

@Component({
  selector: 'app-view-advt-bill',
  templateUrl: './view-advt-bill.component.html',
  styleUrls: ['./view-advt-bill.component.scss'],
})
export class ViewAdvtBillComponent implements OnInit {
  viewData;
  isLoading = false;

  filteredShowData = [];

  constructor(
    private dialogRef: MatDialogRef<ViewAdvtBillComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
    debugger
    this.isLoading = false;
    this.viewData = this.data['advtData'];
    // console.log(this.viewData);

    this.setData();
  }

  issueName: any;
  percentage:any=0
  setData() {
    if (!this.viewData) {
      this.isLoading = false;
      alert('Data is not Present.');
      this.dialogRef.close();
    }
    if (Object.keys(this.viewData).length > 0) {
      // console.log('called', this.viewData);

      for (let index = 0; index < this.viewData.length; index++) {
        debugger
        let showData:any = {
          invoice_no: '',
          invoice_date: '',
          issueName: '',
          advt_name: '',
          address: '',
          state: '',
          cust_gst_no: '',
          cust_name: '',
          ro_no:'',
          ro_date:'',
          percentage1:this.viewData[index].percentage1,
          per:this.viewData[index].per,
          advt_order_no: '',
          advt_order_date: '',
          balance_amt_by_name:'',
          balance_amt:'',

          firstweek: {
            id: 0,
            issue_date: '',
            advt_size: '',
            page_no: '',
            hsn: '',
            advt_rate: '',
            dis: '',
            net: '',
            cgst: 0,
            sgst: 0,
            igst: 0,
            round_off: 0,
            total: 0,
            ro_no:'',
            ro_date:'',
            gst_type:'',
            issueName: '',
          },
          secondweek: {
            id: 0,
            issue_date: '',
            advt_size: '',
            page_no: '',
            hsn: '',
            advt_rate: '',
            dis: '',
            net: '',
            cgst: '',
            sgst: '',
            igst: 0,
            round_off: '',
            total: '',
            ro_no:'',
            ro_date:'',
            gst_type:'',
            issueName: '',
          },
          thirdweek: {
            id: 0,
            issue_date: '',
            advt_size: '',
            page_no: '',
            hsn: '',
            advt_rate: '',
            dis: '',
            net: '',
            cgst: '',
            sgst: '',
            igst: 0,
            round_off: '',
            total: '',
            ro_no:'',
            ro_date:'',
            gst_type:'',
            issueName: '',
          },
          fourthweek: {
            id: 0,
            issue_date: '',
            advt_size: '',
            page_no: '',
            hsn: '',
            advt_rate: '',
            dis: '',
            net: '',
            cgst: '',
            sgst: '',
            igst: 0,
            round_off: '',
            total: '',
            ro_no:'',
            ro_date:'',
            gst_type:'',
            issueName: '',
          },
          fifthweek: {
            id: 0,
            issue_date: '',
            advt_size: '',
            page_no: '',
            hsn: '',
            advt_rate: '',
            dis: '',
            net: '',
            cgst: '',
            sgst: '',
            igst: 0,
            round_off: '',
            total: '',
            ro_no:'',
            ro_date:'',
            gst_type:'',
            issueName: '',
          },
          total_amt: {
            page_no: 0,
            advt_rate: 0,
            dis: 0,
            net: 0,
            cgst: 0,
            sgst: 0,
            igst: 0,
            round_off: 0,
            total: 0,
          },
          total_in_words: '',
          pre_bal: 0,
          total: 0,
          remaining_amt: 0,
        };
        debugger
        this.service
          .getBasicInfoOfAdvtInvoice(
            this.viewData[index]['first_week_id'] ??
              this.viewData[index]['second_week_id'] ??
              this.viewData[index]['third_week_id'] ??
              this.viewData[index]['fourth_week_id'] ??
              this.viewData[index]['fifth_week_id']
          )
          .subscribe((res) => {
            // console.log(res);
            showData['advt_order_no'] = res[0]['booking_no'];
            showData['advt_order_date'] = res[0]['booking_date'];
            showData['cust_name'] = res[0]['cust_name'];
            showData['ro_no'] = res[0]['ro_no'];
            showData['ro_date'] = res[0]['ro_date'];
            showData['cust_gst_no'] = res[0]['gstno'];
            showData['address'] = res[0]['address'];
            showData['state'] = res[0]['state'];
            
            // showData['issueName'] = res[0]['issueName'];
          });

        showData['advt_name'] = this.viewData[index]['advt_name'];
        showData['invoice_no'] = this.viewData[index]['invoice_no'];
        showData['invoice_date'] = this.viewData[index]['invoice_date'];
        showData['balance_amt_by_name'] = this.viewData[index]['balance_amt_by_name'];
        showData['balance_amt'] = this.viewData[index]['balance_amt'];


        // for (let index = 0; index < this.viewData[index].length; index++) {
        // let issuedate = this.viewData[index]['DS_ISSUEDATE'].split(',')[0];

        // showData['total_in_words'] = new ToWords().convert(
        //   showData['total_amt']['total'],
        //   {
        //     currency: true,
        //   }
        // );
        // showData['pre_bal'] = ;
        // showData['total'] = showData['total_amt']['total'];
        // showData['remaining_amt'] =
        //   showData['pre_bal'] + showData['total'];
        debugger
        if (this.viewData[index]['first_week_id'] != null) {
          console.log('first', parseInt(this.viewData[index]['first_week_id']));
          this.percentage= parseFloat(this.viewData[index]['first_week_percentage'])
          showData['firstweek']['id'] = this.viewData[index]['first_week_id'];
          showData['firstweek']['issue_date'] =
            this.viewData[index]['first_week_issue_date'].split(',')[0];
            showData['firstweek']['issueName'] =
            this.viewData[index]['first_week_issue_name'];
          showData['firstweek']['advt_size'] =
            this.viewData[index]['first_week_advt_size'];
          showData['firstweek']['page_no'] =
            this.viewData[index]['first_week_pages_no'];
          showData['firstweek']['hsn'] = '998363';
          showData['firstweek']['advt_rate'] =
            this.viewData[index]['first_week_advt_amt'];
          showData['firstweek']['dis'] =
            this.viewData[index]['first_week_advt_discnt'];
          showData['firstweek']['net'] =
            this.viewData[index]['first_week_amount'];
          showData['firstweek']['cgst'] =parseFloat(this.viewData[index]['first_week_cgst']);
          showData['firstweek']['sgst'] =
          parseFloat( this.viewData[index]['first_week_sgst']);
          showData['firstweek']['gst_type'] =
          this.viewData[index]['first_gst_include_exclude'];
          showData['firstweek']['igst'] =
            Number(this.viewData[index]['first_week_igst']);
          showData['firstweek']['round_off'] =
            this.viewData[index]['first_week_total_amount'];
          showData['firstweek']['total'] =
            this.viewData[index]['first_week_total_amount'];
          showData['total_amt']['page_no'] += parseInt(
            this.viewData[index]['first_week_pages_no']
          );
          showData['total_amt']['advt_rate'] += parseInt(
            this.viewData[index]['first_week_advt_amt']
          );
          showData['total_amt']['dis'] += parseInt(
            this.viewData[index]['first_week_advt_discnt']
          );
          showData['total_amt']['net'] += parseInt(
            this.viewData[index]['first_week_amount']
          );
        
          showData['total_amt']['cgst'] += parseInt(
            this.viewData[index]['first_week_cgst']
          )/this.percentage;
          showData['total_amt']['sgst'] += parseInt(
            this.viewData[index]['first_week_sgst']
          )/this.percentage;
          showData['total_amt']['igst'] += parseInt(
            this.viewData[index]['first_week_igst']
          );
          showData['total_amt']['round_off'] += parseInt(
            this.viewData[index]['first_week_total_amount']
          );
          showData['total_amt']['total'] += parseInt(
            this.viewData[index]['first_week_total_amount']
          );
        } 
         if (this.viewData[index]['second_week_id'] != null) {
          
          this.percentage= parseFloat(this.viewData[index]['second_week_percentage'])
          showData['secondweek']['id'] = this.viewData[index]['second_week_id'];
          showData['secondweek']['issue_date'] =
            this.viewData[index]['second_week_issue_date'].split(',')[0];
            showData['secondweek']['issueName'] =
            this.viewData[index]['second_week_issue_name'];
          showData['secondweek']['advt_size'] =
            this.viewData[index]['second_week_advt_size'];
          showData['secondweek']['page_no'] =
            this.viewData[index]['second_week_pages_no'];
          showData['secondweek']['hsn'] = '998363';
          showData['secondweek']['advt_rate'] =
            this.viewData[index]['second_week_advt_amt'];
          showData['secondweek']['dis'] =
            this.viewData[index]['second_week_advt_discnt'];
          showData['secondweek']['net'] =
            this.viewData[index]['second_week_amount'];
          showData['secondweek']['cgst'] =
            parseFloat(this.viewData[index]['second_week_cgst']);
            showData['secondweek']['gst_type'] =
            this.viewData[index]['second_gst_include_exclude'];
          showData['secondweek']['sgst'] =
           parseFloat(this.viewData[index]['second_week_sgst']);
          showData['secondweek']['igst'] =
          Number(this.viewData[index]['second_week_igst']);
          showData['secondweek']['round_off'] =
            this.viewData[index]['second_week_total_amount'];
          showData['secondweek']['total'] =
            this.viewData[index]['second_week_total_amount'];

          showData['total_amt']['page_no'] += parseInt(
            this.viewData[index]['second_week_pages_no']
          );
          showData['total_amt']['advt_rate'] += parseInt(
            this.viewData[index]['second_week_advt_amt']
          );
          showData['total_amt']['dis'] += parseInt(
            this.viewData[index]['second_week_advt_discnt']
          );
          showData['total_amt']['net'] += parseInt(
            this.viewData[index]['second_week_amount']
          );
          showData['total_amt']['cgst'] += parseInt(
            this.viewData[index]['second_week_cgst']
          )/this.percentage;
          showData['total_amt']['sgst'] += parseInt(
            this.viewData[index]['second_week_sgst']
          )/this.percentage;
          showData['total_amt']['igst'] += parseInt(
            this.viewData[index]['second_week_igst']
          );
          showData['total_amt']['round_off'] += parseInt(
            this.viewData[index]['second_week_total_amount']
          );
          showData['total_amt']['total'] += parseInt(
            this.viewData[index]['second_week_total_amount']
          );
        } 
         if (this.viewData[index]['third_week_id'] != null) {
          
          this.percentage= parseFloat(this.viewData[index]['third_week_percentage'])
          showData['thirdweek']['id'] = this.viewData[index]['third_week_id'];
          showData['thirdweek']['issue_date'] =
            this.viewData[index]['third_week_issue_date'].split(',')[0];
            showData['thirdweek']['issueName'] =
            this.viewData[index]['third_week_issue_name'];
          showData['thirdweek']['advt_size'] =
            this.viewData[index]['third_week_advt_size'];
          showData['thirdweek']['page_no'] =
            this.viewData[index]['third_week_pages_no'];
          showData['thirdweek']['hsn'] = '998363';
          showData['thirdweek']['advt_rate'] =
            this.viewData[index]['third_week_advt_amt'];
          showData['thirdweek']['dis'] =
            this.viewData[index]['third_week_advt_discnt'];
          showData['thirdweek']['net'] =
            this.viewData[index]['third_week_amount'];
          showData['thirdweek']['cgst'] =
            parseFloat(this.viewData[index]['third_week_cgst']);
          showData['thirdweek']['sgst'] =
            parseFloat(this.viewData[index]['third_week_sgst']);
            showData['thirdweek']['gst_type'] =
            this.viewData[index]['third_gst_include_exclude'];
          showData['thirdweek']['igst'] =
          Number(this.viewData[index]['third_week_igst']);
          showData['thirdweek']['round_off'] =
            this.viewData[index]['third_week_total_amount'];
          showData['thirdweek']['total'] =
            this.viewData[index]['third_week_total_amount'];

          showData['total_amt']['page_no'] += parseInt(
            this.viewData[index]['third_week_pages_no']
          );
          showData['total_amt']['advt_rate'] += parseInt(
            this.viewData[index]['third_week_advt_amt']
          );
          showData['total_amt']['dis'] += parseInt(
            this.viewData[index]['third_week_advt_discnt']
          );
          showData['total_amt']['net'] += parseInt(
            this.viewData[index]['third_week_amount']
          );
          showData['total_amt']['cgst'] += parseInt(
            this.viewData[index]['third_week_cgst']
          )/this.percentage;
          showData['total_amt']['sgst'] += parseInt(
            this.viewData[index]['third_week_sgst']
          )/this.percentage;
          showData['total_amt']['igst'] += parseInt(
            this.viewData[index]['third_week_igst']
          );
          showData['total_amt']['round_off'] += parseInt(
            this.viewData[index]['third_week_total_amount']
          );
          showData['total_amt']['total'] += parseInt(
            this.viewData[index]['third_week_total_amount']
          );
        } 
         if (this.viewData[index]['fourth_week_id'] != null) {
          this.percentage= parseFloat(this.viewData[index]['fourth_week_percentage'])
          showData['fourthweek']['id'] = this.viewData[index]['fourth_week_id'];
          showData['fourthweek']['issue_date'] =
            this.viewData[index]['fourth_week_issue_date'].split(',')[0];
            showData['fourthweek']['issueName'] =
            this.viewData[index]['fourth_week_issue_name'];
          showData['fourthweek']['advt_size'] =
            this.viewData[index]['fourth_week_advt_size'];
          showData['fourthweek']['page_no'] =
            this.viewData[index]['fourth_week_pages_no'];
          showData['fourthweek']['hsn'] = '998363';
          showData['fourthweek']['advt_rate'] =
            this.viewData[index]['fourth_week_advt_amt'];
          showData['fourthweek']['dis'] =
            this.viewData[index]['fourth_week_advt_discnt'];
          showData['fourthweek']['net'] =
            this.viewData[index]['fourth_week_amount'];
          showData['fourthweek']['cgst'] =
            Number(this.viewData[index]['fourth_week_cgst']);
          showData['fourthweek']['sgst'] =
            Number(this.viewData[index]['fourth_week_sgst']);
            showData['fourthweek']['gst_type'] =
            this.viewData[index]['fourth_gst_include_exclude'];
          showData['fourthweek']['igst'] =
          Number(this.viewData[index]['fourth_week_igst']);
          showData['fourthweek']['round_off'] =
            this.viewData[index]['fourth_week_total_amount'];
          showData['fourthweek']['total'] =
            this.viewData[index]['fourth_week_total_amount'];

          showData['total_amt']['page_no'] += parseInt(
            this.viewData[index]['fourth_week_pages_no']
          );
          showData['total_amt']['advt_rate'] += parseInt(
            this.viewData[index]['fourth_week_advt_amt']
          );
          showData['total_amt']['dis'] += parseInt(
            this.viewData[index]['fourth_week_advt_discnt']
          );
          showData['total_amt']['net'] += parseInt(
            this.viewData[index]['fourth_week_amount']
          );
          showData['total_amt']['cgst'] += parseInt(
            this.viewData[index]['fourth_week_cgst']
          )/this.percentage;
          showData['total_amt']['sgst'] += parseInt(
            this.viewData[index]['fourth_week_sgst']
          )/this.percentage;
          showData['total_amt']['igst'] += parseInt(
            this.viewData[index]['fourth_week_igst']
          );
          showData['total_amt']['round_off'] += parseInt(
            this.viewData[index]['fourth_week_total_amount']
          );
          showData['total_amt']['total'] += parseInt(
            this.viewData[index]['fourth_week_total_amount']
          );
        } 
         if (this.viewData[index]['fifth_week_id'] != null) {
          this.percentage= parseFloat(this.viewData[index]['fifth_week_percentage'])
          showData['fifthweek']['id'] = this.viewData[index]['fifth_week_id'];
          showData['fifthweek']['issue_date'] =
            this.viewData[index]['fifth_week_issue_date'].split(',')[0];
            showData['fifthweek']['issueName'] =
            this.viewData[index]['fifth_week_issue_name'];
          showData['fifthweek']['advt_size'] =
            this.viewData[index]['fifth_week_advt_size'];
          showData['fifthweek']['page_no'] =
            this.viewData[index]['fifth_week_pages_no'];
          showData['fifthweek']['hsn'] = '998363';
          showData['fifthweek']['advt_rate'] =
            this.viewData[index]['fifth_week_advt_amt'];
          showData['fifthweek']['dis'] =
            this.viewData[index]['fifth_week_advt_discnt'];
          showData['fifthweek']['net'] =
            this.viewData[index]['fifth_week_amount'];
          showData['fifthweek']['cgst'] =
            parseFloat(this.viewData[index]['fifth_week_cgst']);
          showData['fifthweek']['sgst'] =
            parseFloat(this.viewData[index]['fifth_week_sgst']);
            showData['fifthweek']['gst_type'] =
            this.viewData[index]['fifth_gst_include_exclude'];
          showData['fifthweek']['igst'] =
          Number(this.viewData[index]['fifth_week_igst']);
          showData['fifthweek']['round_off'] =
            this.viewData[index]['fifth_week_total_amount'];
          showData['fifthweek']['total'] =
            this.viewData[index]['fifth_week_total_amount'];

          showData['total_amt']['page_no'] += parseInt(
            this.viewData[index]['fifth_week_pages_no']
          );
          showData['total_amt']['advt_rate'] += parseInt(
            this.viewData[index]['fifth_week_advt_amt']
          );
          showData['total_amt']['dis'] += parseInt(
            this.viewData[index]['fifth_week_advt_discnt']
          );
          showData['total_amt']['net'] += parseInt(
            this.viewData[index]['fifth_week_amount']
          );
          showData['total_amt']['cgst'] += parseInt(
            this.viewData[index]['fifth_week_cgst']
          );
          showData['total_amt']['sgst'] += parseInt(
            this.viewData[index]['fifth_week_sgst']
          );
          showData['total_amt']['igst'] += parseInt(
            this.viewData[index]['fifth_week_igst']
          );
          showData['total_amt']['round_off'] += parseInt(
            this.viewData[index]['fifth_week_total_amount']
          );
          showData['total_amt']['total'] += parseInt(
            this.viewData[index]['fifth_week_total_amount']
          );
        }
        showData.total_in_words = new ToWords().convert(showData.total_amt.net ,{ currency: true });

        // showData['total_in_words'] = new ToWords().convert(
        //   showData['total_amt']['total'],
        //   {
        //     currency: true,
        //   }
        // );
        // showData['pre_bal'] = ;
        showData['total'] = showData['total_amt']['total'];
        showData['remaining_amt'] = showData['pre_bal'] + showData['total'];
        // }

        this.filteredShowData.push(showData);
        console.log('filtered', this.filteredShowData);
        if (index == this.viewData.length - 1) {
          this.isLoading = false;
        }
        console.log(showData, "this is show data")
      }
    }
  }
  transform(value: any): any {
    // Use moment.js to parse the date string
    const date = moment(value, 'DD/MM/YYYY');
    // Format the date to return only the month name
    return date.format('MMMM');
  }

  calculateDiscount(dis: any, total: any) {
    return Math.round((Number(total) * Number(dis)) / 100);
}


  parseNumber(value) {
    return Number(value) || 0; // Ensures a valid number, prevents NaN
  }

  calculateNetAmount(weekData: any): number {
    if (!weekData || !weekData['total']) return 0;
    debugger
    let totalAmount = Number(weekData['total']); // Basic Amount
    let discountPercentage = Number(weekData['dis']) || 0;

    // **Step 1: Apply Discount First**
    let discountAmount = (totalAmount * discountPercentage) / 100;
    totalAmount -= discountAmount; // Subtract discount from total

    // **Step 2: If GST is Inclusive, Remove GST**
    if (weekData['gst_type'] !== 'gstExclude') {
        let gstAmount = Number(weekData['cgst']) + Number(weekData['sgst']) + Number(weekData['igst']);
        totalAmount -= gstAmount; // Subtract GST only if it's included
    }

    return Number(weekData['advt_rate'] );
}

calculateFinalAmount(weekData: any): number {
  debugger
  if (!weekData || !weekData['total']) return 0;

  let totalAmount = Number(weekData['total']); // Base amount
  let discountPercentage = Number(weekData['dis']) || 0;

  // **Step 1: Apply Discount**
  let discountAmount = (totalAmount * discountPercentage) / 100;
  totalAmount -= discountAmount; // Subtract discount

  // **Step 2: Add GST Components (CGST, SGST, IGST)**
  let cgst = Number(weekData['cgst']) || 0;
  let sgst = Number(weekData['sgst']) || 0;
  let igst = Number(weekData['igst']) || 0;

  return Math.round(totalAmount + cgst + sgst + igst);
}

convertToWords(amount: any): string {
  return new ToWords().convert(amount, { currency: true }); 
}

getTotalAmtInWords(showData: any) {
  let final_amt = ['firstweek', 'secondweek', 'thirdweek', 'fourthweek', 'fifthweek']
    .reduce((sum, week) => {
      let weekData = showData[week] || {};
      let weekTotal = (this.calculateNetAmount(weekData) || 0) + 
                      (weekData.cgst || 0) + 
                      (weekData.sgst || 0) + 
                      (weekData.igst || 0);
      return sum + weekTotal;
    }, 0);

  console.log("Final Amount:", final_amt); // Debugging
  return this.convertToWords(final_amt);
}


// get totalBalance(): number {
//     const prev = this.parseNumber(this.viewData?.balance_amt || 0);
//     const curr = this.parseNumber(this.viewData?.balance_amt_by_name || 0);
    
//     // Calculate total payable
//     const totalPayable = 
//         this.parseNumber(this.viewData?.['first_week_amount'] || 0) +
//         this.parseNumber(this.viewData?.['second_week_amount'] || 0) +
//         this.parseNumber(this.viewData?.['third_week_amount'] || 0) +
//         this.parseNumber(this.viewData?.['fourth_week_amount'] || 0) +
//         this.parseNumber(this.viewData?.['fifth_week_amount'] || 0);
    
//     // Apply your business logic
//     if (prev === 0) {
//         return totalPayable + curr;  // totalPayable + 0 + curr
//     } else {
//         return prev + curr;  // Ignore totalPayable when prev is not zero
//     }
// }

// TypeScript Component Code

// Method to calculate invoice total (GST अगोदर + all taxes)
calculateInvoiceTotal(showData: any): number {
    const firstWeek = this.parseNumber(this.calculateNetAmount(showData['firstweek'])) +
        this.parseNumber(showData['firstweek']['cgst']) +
        this.parseNumber(showData['firstweek']['sgst']) +
        this.parseNumber(showData['firstweek']['igst']);

    const secondWeek = this.parseNumber(this.calculateNetAmount(showData['secondweek'])) +
        this.parseNumber(showData['secondweek']['cgst']) +
        this.parseNumber(showData['secondweek']['sgst']) +
        this.parseNumber(showData['secondweek']['igst']);

    const thirdWeek = this.parseNumber(this.calculateNetAmount(showData['thirdweek'])) +
        this.parseNumber(showData['thirdweek']['cgst']) +
        this.parseNumber(showData['thirdweek']['sgst']) +
        this.parseNumber(showData['thirdweek']['igst']);

    const fourthWeek = this.parseNumber(this.calculateNetAmount(showData['fourthweek'])) +
        this.parseNumber(showData['fourthweek']['cgst']) +
        this.parseNumber(showData['fourthweek']['sgst']) +
        this.parseNumber(showData['fourthweek']['igst']);

    const fifthWeek = this.parseNumber(this.calculateNetAmount(showData['fifthweek'])) +
        this.parseNumber(showData['fifthweek']['cgst']) +
        this.parseNumber(showData['fifthweek']['sgst']) +
        this.parseNumber(showData['fifthweek']['igst']);

    return firstWeek + secondWeek + thirdWeek + fourthWeek + fifthWeek;
}

// Method to calculate total balance for specific invoice
getTotalBalance(showData: any, currentIndex: number): number {
    const previousBalance = this.parseNumber(showData['balance_amt_by_name'] || 0);
    const currentInvoiceTotal = this.calculateInvoiceTotal(showData);
    
    return previousBalance + currentInvoiceTotal;
}

// Alternative: If you need CUMULATIVE balance across all invoices
getCumulativeBalance(currentIndex: number): number {
    let cumulativeBalance = 0;
    
    // Add up all previous invoices' balances and totals
    for (let i = 0; i <= currentIndex; i++) {
        const invoice = this.filteredShowData[i];
        
        if (i === 0) {
            // First invoice: use its previous balance
            cumulativeBalance = this.parseNumber(invoice['balance_amt_by_name'] || 0);
        }
        
        // Add current invoice total
        cumulativeBalance += this.calculateInvoiceTotal(invoice);
    }
    
    return cumulativeBalance;
}

// Helper method (keep your existing parseNumber method)
// parseNumber(value: any): number {
//     if (value === null || value === undefined || value === '') {
//         return 0;
//     }
//     const parsed = typeof value === 'string' ? parseFloat(value) : Number(value);
//     return isNaN(parsed) ? 0 : parsed;
// }


}
